export const MOOD_COLORS = {
  Apathy: "#A0B8D9",
  Flow: "#FFD700",
  Anxiety: "#FF8042",
  AnxietyApathy: "#D3D3D3", // Light gray for merged anxiety + apathy
  Burnout: "#8B5CF6", // Violet for burnout (anxiety + apathy)
  FlowConfident: "#D3D3D3", // Gray for merged Flow + Confident
  Confident: "#A7E08E",
  Control: "#A7E08E",
  Other: "#D3D3D3",
};
